export const adminAccount = [
  {
    id: 1,
    name: "Admin 1",
    email: "admin@gmail.com",
    password: "123456",
    token: "abcdefghijklmnopqrst"
  },
  {
    id: 2,
    name: "Admin 2",
    email: "admin2@gmail.com",
    password: "123456",
    token: "ijkkelldjnfnfnfnfnf"
  }
];

export const userAccounts = [
  {
    id: 1,
    name: "User 1",
    email: "user1@gmail.com",
    password: "123456",
    token: "user1@dfdfjsdfjsdfnf"
  },
  {
    id: 2,
    name: "User 2",
    email: "user2@gmail.com",
    password: "123456",
    token: "user2@nbnghgnvbgffb"
  },
  {
    id: 3,
    name: "User 3",
    email: "user3@gmail.com",
    password: "123456",
    token: "user3@httutyutrhgbdf"
  }
];
